import React from 'react';

import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Link } from 'react-router-dom';

import { Breadcrumb } from '../../../components/Breadcrumb';
import { Button } from '../../../components/Button';
import { Footer } from '../../../components/Footer';
import { Header } from '../../../components/Header';
import { Tag } from '../../../components/Tag';
import './style.css';

import DateUtils from '../../../utils/DateUtils';

import PreviewBox from '../../../components/PreviewBox/PreviewBox';

import EmbeddedVideo from '../../../components/EmbeddedVideo/EmbeddedVideo';

export const VideoAufbereitung = ({
    portalResource,
    footerPortalResources,
    serverSettings,
}) => {
    const navigate = useNavigate();

    const [selectedSection, setSelectedSection] = useState(0);

    useEffect(() => {
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    if (null == portalResource || null == footerPortalResources) {
        return null;
    }

    return (
        <div className="videoaufbereitung">
            <Header
                className="design-component-instance-node-5"
                style="desktop"
                shareFeedbackEmailAddress={
                    serverSettings.shareFeedbackEmailAddress
                }
                logoDimensions={{
                    height: 64 * 1.8 + 'px',
                    width: 104 * 1.8 + 'px',
                }}
            />

            {buildIntroductoryInfoPart(portalResource)}

            <Footer
                className="design-component-instance-node-5"
                logosPartnersGroupLogoPartnerBundesministerium="/img/BMBFSFJ_gefoerdert_vom_deutsch_Web_c.svg"
                property1="desktop"
            />
        </div>
    );

    function buildRatingsStarDisplay(aggregateUserRating) {
        let stars = [];

        // Calc number of full stars
        let numFullStars = Math.floor(aggregateUserRating);

        for (let i = 0; i < numFullStars; i++) {
            stars.push(
                <img
                    key={'userRating-full-star-' + i}
                    className="img-4"
                    alt="Star fill"
                    src="/img/star-fill-10.svg"
                />,
            );
        }

        // Then do the half stars
        let leftOver = aggregateUserRating - numFullStars;

        if (0.5 <= leftOver) {
            stars.push(
                <img
                    key={'userRating-half-star'}
                    className="img-4"
                    alt="Star half"
                    src="/img/star-half-4.svg"
                />,
            );
        }

        // Finally pad with unfilled stars if needed (assumes we want to show 5 stars)
        let numEmptyStarsNeeded = 5 - stars.length;
        for (let i = 0; i < numEmptyStarsNeeded; i++) {
            stars.push(
                <img
                    key={'userRating-empty-star-' + i}
                    className="img-4"
                    alt="Star"
                    src="/img/star-4.svg"
                />,
            );
        }

        return stars;
    }

    function buildScientificQualityBarsDisplay(
        scientificQualityPdfUrl,
        aggregateScientificQualityRating,
    ) {
        /*
	let filename = "scientific_bars_NUMBER.png";
	
	if(1 > aggregateScientificQualityRating ){
		filename = filename.replace("NUMBER", "0")
	}
	else if(2 > aggregateScientificQualityRating ){
		filename = filename.replace("NUMBER", "1")
	}
	else if(3 > aggregateScientificQualityRating ){
		filename = filename.replace("NUMBER", "2")
	}
	else {
		filename = filename.replace("NUMBER", "3")
	}
	*/

        let filename = 'scientific_bars_3.png';

        return (
            <Link to={scientificQualityPdfUrl} target="_blank">
                <div style={{ display: 'line-flex' }}>
                    <img
                        className="icon-2"
                        alt="Icon"
                        src={'/img/' + filename}
                    />

                    {/*<span style={{marginLeft: "5px"}}>
				{"(" + Number(aggregateScientificQualityRating).toFixed(1)  + ")" }
			</span>*/}
                </div>
            </Link>
        );
    }

    function buildBreadCrumbTitle(shortTitle, fullTitle) {
        if (null != shortTitle) {
            return shortTitle;
        } else {
            return fullTitle;
        }
    }

    function buildIntroductoryInfoPart(portalResource) {
        return (
            <div className="content-wrapper-2">
                <div className="content-11">
                    <div className="frame-24">
                        <div className="frame-25">
                            <div className="frame-26">
                                <Breadcrumb
                                    breadcrumb="two-level"
                                    className="design-component-instance-node-6"
                                    breadcrumbText={buildBreadCrumbTitle(
                                        portalResource.shortTitle,
                                        portalResource.title,
                                    )}
                                />
                                <div className="h">{portalResource.title}</div>
                                <div className="h-2">
                                    {
                                        null != portalResource.subTitle
                                            ? portalResource.subTitle
                                            : null /*Gamification beim Lernen*/
                                    }
                                </div>
                            </div>

                            <div className="div-17">
                                <Tag
                                    className="design-component-instance-node-6"
                                    size="default"
                                    stateProp="default"
                                    style="default"
                                    text={portalResource.mediaUsageGoal.goal}
                                    isClickable={false}
                                />

                                {null == portalResource.subjectMatterCategories
                                    ? null
                                    : portalResource.subjectMatterCategories.map(
                                          (cat, i) => {
                                              return (
                                                  <Tag
                                                      className="design-component-instance-node-6"
                                                      size="default"
                                                      stateProp="default"
                                                      style="default"
                                                      text={cat.category}
                                                      isClickable={false}
                                                  />
                                              );
                                          },
                                      )}

                                {null == portalResource.schoolTypes
                                    ? null
                                    : portalResource.schoolTypes.map(
                                          (schoolType, i) => {
                                              return (
                                                  <Tag
                                                      className="design-component-instance-node-6"
                                                      size="default"
                                                      stateProp="default"
                                                      style="default"
                                                      text={schoolType.name}
                                                      isClickable={false}
                                                  />
                                              );
                                          },
                                      )}

                                {
                                    // leaving this here to document that tags can also appear as "featured"
                                    /*}<Tag
                  className="design-component-instance-node-6"
                  size="default"
                  stateProp="default"
                  style="featured"
                  text="Aufbereitung"
                />*/
                                }
                            </div>

                            {/* Indicators section */}

                            <div className="frame-27">
                                {!portalResource.isScientificRatingVisible ? null : (
                                    <div className="icon-box">
                                        {buildScientificQualityBarsDisplay(
                                            portalResource.scientificQualityPdfUrl,
                                            portalResource.aggregateScientificQualityRating,
                                        )}
                                        <div className="heading-3">
                                            Wissenschaftliche Qualität
                                        </div>
                                    </div>
                                )}

                                <div className="icon-box">
                                    <img
                                        className="icon-2"
                                        alt="Icon"
                                        src="/img/icon-2.svg"
                                    />
                                    <div className="heading-3">
                                        ca.{' '}
                                        {DateUtils.formatReadingTimeDuration(
                                            portalResource.estimatedReadingTimeInMinutes,
                                        )}
                                    </div>
                                </div>

                                {!portalResource.isUserRatingVisible ? null : (
                                    <div className="icon-box">
                                        <div className="icon-3">
                                            <div className="frame-28">
                                                {buildRatingsStarDisplay(
                                                    portalResource.aggregateUserRating,
                                                )}
                                            </div>
                                        </div>
                                        <div className="heading-3">
                                            User rating
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Authoring section */}

                            <div className="frame-27">
                                {null == portalResource.authors
                                    ? null
                                    : portalResource.authors.map(
                                          (author, i) => {
                                              return (
                                                  <div
                                                      key={'author-' + i}
                                                      className="member-avatar"
                                                  >
                                                      <div className="avatar">
                                                          {buildAuthorPicture(
                                                              author,
                                                          )}
                                                      </div>

                                                      <div className="text-and-supporting-3">
                                                          <label
                                                              className="username"
                                                              htmlFor="input-2"
                                                          >
                                                              {author.firstName +
                                                                  ' ' +
                                                                  author.lastName}
                                                          </label>
                                                          {null ==
                                                          author.email ? null : (
                                                              <input
                                                                  className="email-2"
                                                                  id="input-2"
                                                                  placeholder={
                                                                      null ==
                                                                      author.email
                                                                          ? null
                                                                          : author.email
                                                                  }
                                                                  type="text"
                                                              />
                                                          )}
                                                      </div>
                                                  </div>
                                              );
                                          },
                                      )}
                            </div>
                        </div>

                        <div className="featured-image">
                            <div className="frame-29">
								<EmbeddedVideo src={portalResource.titleVideo}/>
							</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function buildAuthorPicture(author) {
        if (null == author.authorPhoto) {
            return <div className="profile-img" />;
        } else {
            return (
                <div
                    className="profile-img"
                    style={{
                        backgroundImage: "url('" + author.authorPhoto + "')",
                    }}
                />
            );
        }
    }

};
